// Types
import type { TAutomatedEmailSentApiRow, TSentEmail } from '~/modules/opportunities/automated-email/types';

import { DateTimeFormatter } from '~/misc/utils/datetime/formatter';

import { labelFromOutboxTriggerName } from '~/modules/opportunities/automated-email/outbox/utils/map-outbox-api';

function sentModeApiToDisplay(mode: string): string {
  if (mode === 'fully-automated') {
    return 'Fully automated';
  }

  if (mode === 'semi-automated') {
    return 'Semi-automatic';
  }

  return mode;
}

export function mapAutomatedEmailSentApiRow(row: TAutomatedEmailSentApiRow): TSentEmail {
  return {
    id: row.id,
    opportunity_id: row.opportunity_id,
    listing_id: row.listing_id,
    patch_id: row.patch_id,
    sale_type: row.sale_type,
    contact_id: row.contact_id,
    contact_name: row.contact_name,
    contact_email: row.contact_email,
    property_address: row.property_address,
    trigger_name: row.trigger_name,
    trigger: labelFromOutboxTriggerName(row.trigger_name),
    subject: row.subject,
    content: row.content,
    date_sent: DateTimeFormatter.toFullDateTime(row.sent_at) || row.sent_at,
    mode: sentModeApiToDisplay(row.mode),
  };
}
